import { cva, type VariantProps } from '@veraclins-dev/cva';

import { styleProps } from './styles';

/** ::::::::: List ::::::::: */
const listVariants = cva({
  base: 'group/list flex flex-col',
  responsive: {
    ...styleProps,
  },
  variants: {
    variant: {
      // Unordered list variants
      'unordered-disc': 'list-disc',
      'unordered-circle': 'list-[circle]',
      'unordered-square': 'list-[square]',
      // Ordered list variants
      'ordered-decimal': 'list-decimal',
      'ordered-roman': 'list-[lower-roman]',
      'ordered-upper-roman': 'list-[upper-roman]',
      'ordered-alpha': 'list-[lower-alpha]',
      'ordered-upper-alpha': 'list-[upper-alpha]',
      // No markers
      none: 'list-none',
    },
    markerPosition: {
      inside: 'list-inside',
      // Markers sit in the start padding, so wrapped lines align with the
      // first word. The gutter width depends on the marker (see below); a
      // list with no marker gets none.
      outside: 'list-outside',
    },
  },
  compoundVariants: [
    {
      markerPosition: 'outside',
      variant: ['unordered-disc', 'unordered-circle', 'unordered-square'],
      className: 'ps-[2em]',
    },
    // Numbers need a wider gutter than bullets: 2.5em fits three-digit
    // numbers and two-letter alpha markers.
    {
      markerPosition: 'outside',
      variant: ['ordered-decimal', 'ordered-alpha', 'ordered-upper-alpha'],
      className: 'ps-[2.5em]',
    },
    // Roman numerals run widest: 3.5em fits up to xxxviii / XXXVIII.
    // Longer lists can widen the gutter with the `ps` style prop.
    {
      markerPosition: 'outside',
      variant: ['ordered-roman', 'ordered-upper-roman'],
      className: 'ps-[3.5em]',
    },
  ],
  defaultVariants: {
    variant: 'none',
    markerPosition: 'inside',
  },
});

type ListVariants = VariantProps<typeof listVariants>;

export { type ListVariants, listVariants };
